<template>
  <div class="d-flex align-items-center justify-content-center">
    <!-- Nút Tìm kiếm -->
    <b-button
      variant="search"
      class="btn-action-base me-2"
      size="sm"
      @click="handleSearch"
    >
      <i class="bx bx-search align-middle me-2"></i>
      Tìm kiếm
    </b-button>

    <!-- Nút Làm mới -->
    <b-button
      class="btn-action-base"
      size="sm"
      @click="handleClear"
    >
      <i class="mdi mdi-replay font-size-16 align-middle me-2"></i>
      Làm mới
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'SearchResetButtons',
  props: {
    // Hàm xử lý tìm kiếm (phải được truyền từ component cha)
    handleSearch: {
      type: Function,
      required: true,
    },
    // Hàm xử lý làm mới (phải được truyền từ component cha)
    handleClear: {
      type: Function,
      required: true,
    },
  }
}
</script>

<style scoped>
/* Class CSS chung cho cả hai nút */
.btn-action-base {
    /* Thiết lập kích thước */
    height: 40px;
    width: 130px;
    font-size: 14px;
    
    /* Thiết lập màu sắc và định dạng */
    background-color: var(--color-accent-yellow) !important; /* Màu nền vàng */
    border: none !important;
    color: var(--color-dark) !important; /* Màu chữ đen */
    font-weight: bold;
    border-radius: 6px; /* Bo góc nhẹ */
    
    /* Thiết lập hiển thị (dùng flex để căn giữa nội dung) */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    
    /* Hiệu ứng chuyển động */
    transition: background-color 0.2s, box-shadow 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-action-base:hover {
    background-color: var(--color-accent-yellow) !important; /* Màu đậm hơn khi hover */
    opacity: 0.9;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Khoảng cách giữa 2 nút được xử lý bằng class Bootstrap `me-2` trên nút Tìm kiếm */
</style>